import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild } from '@angular/core';
import { CommonModule, formatDate  } from '@angular/common';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule, NgSelectComponent } from '@ng-select/ng-select'; // Importa NgSelectModule
import { I18n, CustomDatepickerI18n } from '../../../clases/idioma-fecha';
import { ModalComponent } from '../../modal/modal.component';
import { EjecucionService } from '../../../services/ejecucion.service';
import { InicioService } from '../../../services/inicio.service';


@Component({
  selector: 'app-reprogramacion',
  standalone: true,
  imports: [NgSelectModule, CommonModule, ReactiveFormsModule, ModalComponent, NgbDatepickerModule],
  templateUrl: './reprogramacion.component.html',
  styleUrl: './reprogramacion.component.css',
  providers: [
    //provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class ReprogramacionComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @ViewChild(NgSelectComponent) ngSelectComponent!: NgSelectComponent;

  private srvLogin = inject(InicioService);
  private servicios = inject(EjecucionService);
  private fb = inject(FormBuilder)

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  user: any;
  errorMessage: string = '';
  isActualiza: boolean = false;
  ocupaciones_accion: any = [];
  fechaActual: string = '';
  fechaMas7: string = '';
  datos_ocupacion: any = [];
  datos_perfiles: any = [];
  listarFormador: any = [];
  listarUnidadFormador: any[] = [];
  listCupo: any[] = [];
  turno: any = [];
  tipo_formador: any = [];
  valida: boolean = true;
  espacio: boolean = false;
  fecha: any;

  formularioProgramacion: FormGroup

  espaciosList: string[] = [
    "Centro de Formación Socialísta",
    "Organización",
    "Otro"
  ]

  constructor(){
    this.formularioProgramacion = this.fb.group({
      //id_ocupacion: new FormControl('', [Validators.required]),
      datosUC: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
    this.fecha = new Date();
    this.fechaActual = formatDate(this.fecha, 'dd-MM-yyyy', 'en-US'); // Formato: día/mes/año
    this.fechaMas7 = formatDate((this.fecha.setDate(this.fecha.getDate() + 7)), 'dd-MM-yyyy', 'en-US'); // Suma 7 días a la fecha
    for (let index = 1; index <=50 ; index++) this.listCupo?.push({id: index});
  }

  convierteDtpick(date: string):NgbDateStruct {
    let array = date.split("-");
    return {year: parseInt(array[2]), month: parseInt(array[1]), day: parseInt(array[0])};
  }

  get datosUC() {
    return this.formularioProgramacion.get("datosUC") as FormArray
  }

  unidadesCurriculares(id: number) {
    return (this.formularioProgramacion.get('datosUC') as FormArray)?.at(id)?.get('unidadesCurriculares') as FormArray;
  }

  convertior(numero: number): string {
    return numero < 10 ? `0${numero}` : numero.toString();
  }

  mensaje_validador(){
    if(this.valida){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Debe llenar todos los campos del ciclo formativo inicial.';
      this.mdl.alerta();
    }
  }

  select_espacio(){
    let espacio_formacion = this.formularioProgramacion.get('espacio_formacion')?.getRawValue();
    this.espacio = espacio_formacion == 'Otro' ? true : false;
  }

  verificador(){
    console.log('prueba:  ',this.unidadesCurriculares(0).value)
    for (let i = 0; i < (this.unidadesCurriculares(0).value).length; i++) {
      const e = (this.unidadesCurriculares(0).value)[i];
      if (e.id_formador == ""){
        this.valida = true;
        break;
      }
      else{
        this.valida = false;
      }
    }
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarOcupacion(this.user.id_institucional).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.ocupaciones_accion = rs.data;
        console.log("Datos recibidos:", rs.data);
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }


  cerrar(){
    this.isActualiza = false;
  }

  buscar(ev: any){
    if(ev != undefined){
      this.isActualiza = true;
      this.datos_ocupacion = ev;
      this.turno = [];
      this.tipo_formador = [];
      this.mdl.cargando();
      this.servicios.listarPerfilesOferta(ev.id_accion_formativa_oc).subscribe({
        next: (rs) => {
          const miArray: { key: string; value: any }[] = Object.entries(rs.data.lista_perfiles).map(([key, value]) => ({ key, value }));
          const mover_principio = this.servicios.moverObjeto180AlPrincipio(miArray);
          this.datos_perfiles = this.servicios.identificarDuplicadosEnTodoArray(mover_principio);
          this.turno = rs.data.turnos
          this.tipo_formador = rs.data.tipo_formador
          this.datosUC.clear();
          this.valida = false;
          console.log("Datos recibidos perfiles: ", this.datos_perfiles);
          for (let i = 0; i < this.datos_perfiles.length; i++) {
            const v = this.datos_perfiles[i];
            this.listarUnidadFormador[i] = [];
            // Creamos un FormGroup para cada 'key' y le asignamos el FormArray de UCs
            this.datosUC.push(
              this.fb.group({
                perfilId: [v.key], // Almacenamos la 'key' por si la necesitas
                unidadesCurriculares: this.fb.array([])
              })
            );
            const unidadesCurricularesArray = this.unidadesCurriculares(i)
            v.value.forEach((uc:any) => {




              const fechaInicio = uc.fecha_inicio == 0 ?
              this.convierteDtpick(this.fechaActual) :
              this.convierteDtpick(formatDate(uc.fecha_inicio, 'dd-MM-yyyy', 'en-US'));

              const fechaFin = uc.fecha_culminacion == 0 ?
              this.convierteDtpick(this.fechaMas7) :
              this.convierteDtpick(formatDate(uc.fecha_culminacion , 'dd-MM-yyyy', 'en-US'));

              //console.log('fecha inicio uc:   ',uc.fecha_inicio, '   Fecha setiada:   ',fechaInicio);
              //console.log('fecha fin uc:   ',uc.fecha_culminacion, '   Fecha setiada:   ',fechaFin);

              unidadesCurricularesArray.push(
                this.fb.group({
                  codigo_of: [uc.codigo_of_uc == 0 ? '' : uc.codigo_of_uc],
                  horas: [uc.horas_uc == 0 ? '' : uc.horas_uc],
                  id_oferta_formativa: [uc.id_oferta_formativa == 0 ? '' : uc.id_oferta_formativa],
                  id_perfil_productivo: [uc.id_perfil_productivo == 0 ? '' : uc.id_perfil_productivo],
                  id_accion_formativa: [uc.id_accion_formativa == 0 ? '' : uc.id_accion_formativa],
                  id_accion_formativa_ppl: [uc.id_accion_formativa_ppl == 0 ? '' : uc.id_accion_formativa_ppl],
                  nombre_oferta: [uc.nombre_oferta == 0 ? '' : uc.nombre_oferta],
                  id_turno: [uc.id_turno == 0 ? '1' : uc.id_turno, Validators.required],
                  fecha_inicio: [fechaInicio, Validators.required],
                  fecha_culminacion: [fechaFin, Validators.required],
                  id_tipo_formador: [uc.id_tipo_formador == 0 ? '' : uc.id_tipo_formador, Validators.required],
                  id_formador: [uc.id_facilitador == 0 ? '' : uc.id_facilitador, Validators.required],
                  cupo: [uc.cupo == 0 ? '1' : uc.cupo, Validators.required],
                })
              );
            });
          }
          this.mdl.cerrar();
        },
        error: (error) => {
          this.errorMessage = error.message;
        },
      });
    }
  }

  async getFormador(idp: number, idu: number){
    let tp = this.unidadesCurriculares(idp).at(idu)
    let id_turno = tp.get('id_turno')?.getRawValue();
    const fechaInicio: NgbDateStruct = tp.get('fecha_inicio')?.getRawValue();
    const fechaFin: NgbDateStruct = tp.get('fecha_culminacion')?.getRawValue();
    let id_tipo_formador = tp.get('id_tipo_formador')?.getRawValue() == "" ? 0 : tp.get('id_tipo_formador')?.getRawValue();
    tp.get('id_formador')?.setValue('');
    this.valida = true;
    if(fechaInicio && fechaFin){
      const fechaInicioFormat = `${fechaInicio.year}-${this.convertior(fechaInicio.month)}-${this.convertior(fechaInicio.day)}`;
      const fechaFinFormat = `${fechaFin.year}-${this.convertior(fechaFin.month)}-${this.convertior(fechaFin.day)}`;
      if (Date.parse(fechaInicioFormat) > Date.parse(fechaFinFormat)){
        tp.get('id_formador')?.setValue('');
        tp.get('id_tipo_formador')?.setValue('');
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = 'La fecha de ingreso no puede ser mayor a la fecha de culminación.';
        this.mdl.alerta();
      }
      else{
        let datos = {
          "id_tipo_formador": parseInt(id_tipo_formador),
          "id_turno": parseInt(id_turno),
          "id_estado": this.user.id_estado,
          "fechaInicioFormat": fechaInicioFormat,
          "fechaFinFormat": fechaFinFormat,
        }
        this.mdl.cargando();
        await this.servicios.listarFormador(datos).subscribe({
          next: (rs) => {
            this.mdl.cerrar();
            if(rs.data != 0){
              this.listarFormador = rs.data;
              this.listarUnidadFormador[idp][idu] = rs.data
            }
            else{
              this.listarFormador = [];
              this.listarUnidadFormador[idp][idu] = []
            }
          },
          error: (error) => {
            this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          }
        });
        console.log("Datos recibidos formadores: ", this.listarUnidadFormador[idp][idu]);
      }
    }
  }

  async cargar(){
    for (let i = 0; i < ((this.formularioProgramacion.value).datosUC).length; i++) {
      const element = this.unidadesCurriculares(i).value;
      let j = -1
      element.forEach((dt:any) => {
        j += 1;
        if(dt.fecha_inicio != "" && dt.fecha_culminacion != ""){
          const fechaInicio: NgbDateStruct = this.unidadesCurriculares(i).at(j).get('fecha_inicio')?.getRawValue();
          const fechaFin: NgbDateStruct = this.unidadesCurriculares(i).at(j).get('fecha_culminacion')?.getRawValue();
          dt.fecha_inicio = `${fechaInicio.year}-${this.convertior(fechaInicio.month)}-${this.convertior(fechaInicio.day)}`;
          dt.fecha_culminacion = `${fechaFin.year}-${this.convertior(fechaFin.month)}-${this.convertior(fechaFin.day)}`;
        }
      });
    }
    console.log('aaa:  ',this.datos_ocupacion)
    Object.assign(this.formularioProgramacion.value, {
      'id_accion_formativa_oc': this.datos_ocupacion.id_accion_formativa_oc,
      'id_ocupacion': this.datos_ocupacion.id_ocupacion,
      'id_meta_regional': this.datos_ocupacion.id_meta_regional,
      'preimpreso_acronimo': this.datos_ocupacion.preimpreso_acronimo,
      'id_alternativa_cumplimiento': this.datos_ocupacion.id_alternativa_cumplimiento,
      'id_estado': this.datos_ocupacion.id_estado,
      'id_cfs': this.datos_ocupacion.id_cfs,
      'id_ambito': this.datos_ocupacion.id_ambito
    });
    let valida = ((this.formularioProgramacion.value).datosUC[0].unidadesCurriculares).filter((v:any) => { return v.id_formador == '' ?  0 : v.id_formador; });
    if (valida.length > 0){
      console.log('todo:  ', this.formularioProgramacion.value);
      //if(valida.length == ((this.formularioProgramacion.value).datosUC[0].unidadesCurriculares).length){
        this.mdl.cargando();
        await this.servicios.updateAccionFormativa(this.formularioProgramacion.value).subscribe({
          next: (rs) => {
            console.log('prueba:  ',rs)
            this.mdl.cerrar();
            this.cerrar();
            this.ngSelectComponent.clearModel();
            this.titulo = '!EXITO¡';
            this.tipo_color = 'success';
            this.letra_color = 'light';
            this.mensaje = 'Petición realizada.';
            this.mdl.alerta();
          },
          error: (error) => {
            this.errorMessage = error.message; // Muestra el mensaje de error al usuario
            //console.error("Error en el componente:", error); // Registro del error en el componente
          }
        });
        /*
      }else{
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = `Las unidades curriculares del ciclo formativo inicial, no deben estar vacias.`;
        this.mdl.alerta();
      }
        */
    }
    else
    {
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Al menos debe llenar una(1) unidad curricular del perfiles habilitado.';
      this.mdl.alerta();
    }
  }

}
